import { normalizarMateriaId } from '../materiasCompat';
export const QUESTOES = [];
export const installLegacyQuestions = items => QUESTOES.splice(0, QUESTOES.length, ...items);
export const getQuestoesPorMateria = materia => QUESTOES.filter(q=>q.materia===normalizarMateriaId(materia));
export const getQuestoesPorTipo = tipo => QUESTOES.filter(q=>q.tipo===tipo);
export const getQuestoesPorMateriaETipo = (materia,tipo) => getQuestoesPorMateria(materia).filter(q=>q.tipo===tipo);
export const getQuestoesPorMaterias = (materias,tipo=null) => QUESTOES.filter(q=>materias.map(normalizarMateriaId).includes(q.materia)&&(!tipo||q.tipo===tipo));
export const getQuestoesAleatorias = (items,quantity) => {
  const shuffled=[...items];
  for(let i=shuffled.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[shuffled[i],shuffled[j]]=[shuffled[j],shuffled[i]];}
  return shuffled.slice(0,quantity);
};
export const montarSimulado = (concurso,tipo) => Object.entries(concurso.distribuicao).flatMap(([materia,total])=>getQuestoesAleatorias(getQuestoesPorMateriaETipo(materia,tipo),total));
export default QUESTOES;
